import { Model } from '../model';
import { Paginated } from '../paginated';

export class Subaccount extends Model {
  idSubaccountProfile: number;
  login: string;
  password: string;
  passwordApi: string;
  attribute: Attribute;
  options: Options;
  defaultSender: DefaultSender;
  isSuperaccount: boolean;
  idUser?: number;
}

export class Subaccounts extends Paginated {
  data: Array<Subaccount>;
}

export class Options extends Model {
  idLanguage: string;
  dfeu: boolean;
  use24: boolean;
}

export class Attribute extends Model {
  name: string;
  surname: string;
  email: string;
  mobile: string;
  companyName: string;
  vat: string;
  fiscalCode: string;
  address: string;
  zipCode: string;
  city: string;
  province: string;
  phone: string;
  fax: string;
  invoicingEmail: string;
}

export class DefaultSender extends Model {
  defaultSender: string;
  isSenderLock: boolean;
  isSenderSuperSetted: boolean;
}

export class ApiGetSubaccounts {
  idUser?: number;
  login?: string;
  name?: string;
  surname?: string;
  company?: string;
  idProfile?: number;
  type?: number;
  creditsFrom?: number;
  creditsTo?: number;
}

export enum SearchTypeSubFilter {
  ALL = '0',
  ONLY_FINAL_SUB = '1',
  ONLY_RESELLER = '2'
}

export enum PasswordType {
  WEBAPP = 'WEBAPP',
  API = 'API'
}
